import React, { Component } from "react";
import { connect } from "react-redux";
import Dialog from "material-ui/Dialog";
import FlatButton from "material-ui/FlatButton";
import TextField from "material-ui/TextField";
import * as uiActions from "../store/ui/uiActions";
import * as uiSelectors from "../store/ui/uiSelectors";
import { password as appPassword } from "../constants/config";

const initialState = {
  result: "",
  password: "",
  resultError: false,
  passwordError: false
};

class EditResult extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.show && nextProps.show) {
      window.setTimeout(() => {
        this._inputResult.focus();
      }, 300);
    }
  }

  _onChangeResult = ev => {
    const result = ev.target.value;
    this.setState({ result });
  };

  _onChangePassword = ev => {
    const password = ev.target.value;
    this.setState({ password });
  };

  _onClose = () => {
    const { hide } = this.props;
    this.setState(initialState);
    hide();
  };

  _onSave = () => {
    const { matchId, postEditResult } = this.props;
    const { result, password } = this.state;
    const resultFormatted = result.replace(/ /g, "");
    const resultError = !/^[0-7]-[0-7](,[0-7]-[0-7])?$/g.test(resultFormatted);
    const passwordError = password !== appPassword;
    this.setState({
      resultError,
      passwordError
    });
    if (!resultError && !passwordError) {
      postEditResult(matchId, resultFormatted);
      this._onClose();
    }
  };

  render() {
    const { show } = this.props;
    const { result, password, resultError, passwordError } = this.state;
    return (
      <Dialog
        title="Ange result"
        actions={[
          <FlatButton
            key="dialog-cancel"
            label="Avbryt"
            primary={true}
            onClick={this._onClose}
          />,
          <FlatButton
            key="dialog-submit"
            label="Spara"
            primary={true}
            onClick={this._onSave}
          />
        ]}
        open={show || false}
        onRequestClose={this._onClose}
        contentStyle={styles.container}
      >
        <TextField
          ref={comp => (this._inputResult = comp)}
          value={result}
          onChange={this._onChangeResult}
          hintText="ex. 6-0, 6-2"
          errorText={resultError ? "Resultat i fel format" : null}
        />
        <TextField
          value={password}
          onChange={this._onChangePassword}
          hintText="Lösenord"
          errorText={passwordError ? "Fel lösenord" : null}
          type="password"
        />
      </Dialog>
    );
  }
}

const styles = {
  container: {
    width: 300
  }
};

const mapStateToProps = state => {
  return {
    show: uiSelectors.getEditResultOpen(state),
    matchId: uiSelectors.getEditResultMatchId(state)
  };
};

const mapDispatchToProps = dispatch => {
  return {
    hide: () => dispatch(uiActions.showEditResult(false)),
    postEditResult: (matchId, result) =>
      dispatch(uiActions.postEditResult(matchId, result))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditResult);



// WEBPACK FOOTER //
// ./src/components/EditResult.js